export default __webpack_public_path__ + "static/media/threetop.9e54b44b.png";